import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CloseDialog, OpenDialog, OpenUrl } from './amautas-subscription.actions';
import { patch } from '@ngxs/store/operators';
import { openWindow } from 'src/app/_core/utils/open-window';

export type AmautasSubscriptionStateModel = {
  open: boolean;
};

export const initialState: AmautasSubscriptionStateModel = {
  open: false,
};

@State<AmautasSubscriptionStateModel>({
  name: 'amautasSubscriptionDialog',
  defaults: initialState,
})
@Injectable()
export class AmautasSubscriptionDialogState {

  @Selector()
  static open(state: AmautasSubscriptionStateModel): boolean {
    return state.open;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<AmautasSubscriptionStateModel>) {
    context.setState(
      patch({
        open: true,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<AmautasSubscriptionStateModel>) {
    context.setState(
      patch({
        open: false,
      }),
    );
  }

  @Action(OpenUrl)
  openUrl() {
    const url = 'https://amautas.com/suscripciones/';
    openWindow(url);
  }
}
